import { BranchApi, Branch } from '../models';

export function mapBranchApiToModel(branchApi: BranchApi): Branch {
  return {
    id: branchApi.id,
    name: branchApi.name,
    businessName: branchApi.businessName,
    commerceId: branchApi.commerceId,
    status: branchApi.status,
    externalId: branchApi.externalId,
    externalBranchCode: branchApi.externalBranchCode,
    apiCode: branchApi.apiCode,
    logo: branchApi.logo,
    businessType: branchApi.businessType,
    businessKey: branchApi.businessKey,
    url: branchApi.url,
    phone: branchApi.phone,
    enabled: branchApi.enabled,
    addressId: branchApi.addressId,
    createdAt: branchApi.createdAt,
    updatedAt: branchApi.updatedAt,
    commerceName: branchApi.commerceName,
    fullAddress: branchApi.fullAddress,
    address: branchApi.address,
    commerce: branchApi.commerce,
  };
}
